<template>
    <div class="fixed-scroller">
        <div class="v-alert w-400">
            <header><p>Stamps - {{ item.name }}</p><div class="x" @click="exit"></div></header>
            <div>
                <div v-for="award in item.awards" class="award-item">
                    <p class="ellip">{{ award.name }}</p>
                    <p>{{ award.date }}</p>
                    <p class="ta-r">{{ award.qty }}</p>
                </div>
            </div>
            <div class="btns"> 
                <p class="btn">remove</p>
                <p class="btn">add</p>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: ['item'],
    methods: {
        exit () {
            this.$emit('emit',{ t: 'stamps', action: 'exit' });
        }
    }
}

</script>

<style scoped lang="scss">
.award-item {
    display: grid;
    grid-template-columns: 200px 140px 50px;
    padding: 3px 4px;
    &:nth-child(even) { background-color: rgba(100,100,100,0.2); }
}
</style>